<template>
    <div>
        <FormGroup label="Butik" alias="store" label-cols-md="3" v-slot:default="props" scope="deposit">
            <OptifySelect :options="stores" v-model="order.storeId" :multiple="false" :show-labels="false"
                          @search="search" @select="select" label="text" track-by="id" :internal-search="false" autocomplete="off">
            </OptifySelect>

            <input type="hidden" v-validate="'required'" v-model="order.storeId" data-vv-as="Butik"
                   :class="{ 'is-invalid': !props.state }" name="store" data-vv-scope="deposit" />
        </FormGroup>


        <FormGroup label="Find kunde" alias="contact" label-cols-md="3" v-slot:default="props" scope="deposit">
            <OptifySelect :options="contacts" v-model="order.contactId" :multiple="false" :show-labels="false"
                          @search="search" @select="select" label="text" track-by="id" :internal-search="false" autocomplete="off">
            </OptifySelect>

            <input type="hidden" v-validate="''" v-model="order.contactId" data-vv-as="Kontakt"
                   :class="{ 'is-invalid': !props.state }" name="contact" data-vv-scope="deposit" />
        </FormGroup>


        <hr />

        <h6>Ny kunde</h6>

        <FormGroup label="Navn" alias="name" scope="deposit" label-cols-md="3" v-slot:default="props">
            <b-form-input type="text" v-model="contact.name" :state="props.state" :data-vv-scope="props.scope"
                v-validate="'required'" :name="props.alias" data-vv-as="Navn" autocomplete="off" :disabled="order.contactId"></b-form-input>
        </FormGroup>

        <FormGroup label="E-mail" alias="email" scope="deposit" label-cols-md="3" v-slot:default="props">
            <b-form-input type="text" v-model="contact['5d7b8ad22dce1817fc348cfb']" :state="props.state" :data-vv-scope="props.scope"
                v-validate="'required|email'" :name="props.alias" data-vv-as="E-mail" autocomplete="off" :disabled="order.contactId"></b-form-input>
        </FormGroup>

        <FormGroup label="Telefon" alias="phone" scope="deposit" label-cols-md="3" v-slot:default="props">
            <b-form-input type="text" v-model="contact['5d7b8ae52dce1817fc348cfc']" :state="props.state" :data-vv-scope="props.scope"
                v-validate="'required'" :name="props.alias" data-vv-as="Telefon" autocomplete="off" :disabled="order.contactId"></b-form-input>
        </FormGroup>

    </div>
</template>

<script>
    export default {
        data: () => ({
            contacts: [],
            contact: {
                Id: null,
                owner: null,
                name: null,
                "5d7b8ad22dce1817fc348cfb": null, // Email
                "5d7b8ae52dce1817fc348cfc": null, // Phone
                "5d7b8aff2dce1817fc348d00": "No", // Customer flow
                "627bc9b5fafcb6726419813a": "0001-01-01", // Age/Birthday
                madeToMeasure: [],
            },
            order: {
                owner: null,
                contactId: null,
                organizationId: null,
                subtotal: 0,
                total: 0,
                vat: 0,

                "5d8a03cefa22d02044989335": null, // Store
                "5d8a057dfa22d0204498933d": "Deposit",
                "5d8a0355fa22d02044989332": "Deposit",
                "5d8a0452fa22d02044989336": "Wait for approval",
                "5de4d0649663b9475842a5a5": null, // Customer

                adjustments: [],
                orderLines: [
                    {
                        discount: 0,
                        price: "0",
                        priceWithVat: "0",
                        product: "Deposit",
                        productId: "69e7cf22b07ced4af85eaef3",
                        quantity: 1,
                        specs: {},
                        stock: {},
                        totalPrice: "0",
                    }
                ]
            }
        }),
        inject: ['$validator'],
        components: {},
        computed: {
            stores() {
                return this.fields.find(x => x.name == "5d8a03cefa22d02044989335")?.values.map(x => {
                    return {
                        id: x,
                        text: x
                    }
                }) || []
            }
        },
        watch: {},
        props: ['fields'],
        methods: {
            search(query) {
                this.$http.post("/api/multi-select/contacts", {
                    search: query,
                    //value: this.order.contactId,
                    values: [],
                    taggable: true,
                    fields: ["name", "5d7b8ae52dce1817fc348cfc", "5d7b8ad22dce1817fc348cfb"]
                }).then(x => {
                    this.contacts = x.data;
                });
            },
            select(item) {
                if (item.isNew === true) {
                    this.$http.post("/api/multi-select/contacts/create", {
                        name: item.text
                    }).then(x => {
                        this.order.contactId = x.data.id;
                        this.order['5de4d0649663b9475842a5a5'] = item.text;
                        this.search();
                    });
                }

                this.order['5de4d0649663b9475842a5a5'] = item.name;
                this.contact['5d7b8ad22dce1817fc348cfb'] = item['5d7b8ad22dce1817fc348cfb'];
                this.contact.name = item.name;
                this.contact.Id = item.id;
            },
            async ok() {
                await this.$validator.validate("deposit.*").then(async valid => {
                    if (valid) {

                        if (!this.order.contactId) {
                            await this.createId().then(x => {
                                this.order.contactId = x;

                                this.contact.Id = this.order.contactId;
                                var currentUser = this.$store.state.user;
                                var user = this.$users.find(x => x.email == currentUser);
                                if (user) {
                                    this.contact.owner = user.id;
                                }
                            });

                            await this.$http.post("/api/module/contacts/" + this.contact.Id, this.contact).then(x => {
                                if (x.data === false) {
                                    this.showErrorMsg();
                                } else {
  
                                }
                            });
                        }


                        await this.$http.put("/api/module/orders", this.order).then(x => {
                            if (x.data === false) {
                                this.showErrorMsg();
                            } else {
                                this.$router.push("/orders/" + x.data);
                            }

                            //this.loading = false;
                        }).finally(() => {
                            this.$emit("close");
                        });
                    }
                });
            },
            cancel() {
                this.$emit("close", { test: true });
            }
        },
        created() {
            this.search();

            var currentUser = this.$store.state.user;
            var user = this.$users.find(x => x.email == currentUser);
            if (user) {
                this.order.owner = user.id;
            }
        },
        mounted() { }
    };
</script>